// component imports
import { Component, ChangeDetectionStrategy, Inject, input } from '@angular/core';
import { CONSTANTS } from '../../../constants/constants';

@Component({
    selector: 'app-olci-prompts-inner',
    templateUrl: './olci-prompts-inner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OlciPromptsInnerComponent {
	public readonly layoutState = input<any>();
	public readonly bundle = input<any>();
	public readonly screensize = input<any>();

	constructor(@Inject(CONSTANTS) private readonly constants: any) {}
}
